export const Project = {
  UserRole: {
    VIEWER: 'Viewer',
    EDITOR: 'Editor',
    ADMIN: 'Admin',
  } as const,
} as const;

export interface IProjectUser {
  userId: string;
  email: string;
  role: (typeof Project.UserRole)[keyof typeof Project.UserRole];
}

export interface IProject {
  _id: string;
  name: string;
  projectUsers: IProjectUser[];
  hash: string;
  saveString: string;
  createdAt: string; // ISO 8601 string format
  updatedAt: string; // ISO 8601 string format
}
